<template>
  <div :class="toolbarClasses" v-if="showSharingDetails"> 
    <div class="toolbar-expanded-items" v-bind:style="toolbarStyle"> 
      <div class="map-attributes">
        <div :class="logoClasses">
          <a :href="config.homepage" target="_blank"><img src="/images/ejpaving-logo.jpeg" alt="App Logo" class="app-logo"></a>
        </div>
        <div class="attrs">
          <h1 class="attr-header">Project Description</h1>
          <p class="attr-description">{{ projectName }}</p>
        </div>
        <div class="attrs address">
          <h1 class="attr-header">Address</h1>
          <p class="attr-description">{{ formattedAddress }}</p>
        </div>
        <div :class="['additional-details', $mq]">
          <div class="results attrs">
            <div class="icon">
              <vector-polygon-icon />
            </div>
            <div>
              <h1 class="attr-header">Total Area</h1>
              <p>{{ totalAreaString }}</p>
            </div>
          </div>
          <div class="results attrs estimate">
            <div class="icon">
              <currency-usd-icon />
            </div>
            <div>
              <h1 class="attr-header">Estimate</h1>
              <p>{{ totalPriceFormatted }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="toolbar-controls show">
        <a href="#" title="Make changes to this map" @click.prevent="editMap">
          <span>edit map</span>
          <span class="icon">
            <pencil-icon />
          </span>
        </a>
      </div>      
    </div>
  </div>
</template>

<style scoped>
  .toolbar-container {    
    position: fixed;
    top: 0;    
    left: 0;
    width: 100%;    
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    padding: 0;
    background-color: #fff;
    display: flex;
    flex-direction: row;
  }

  .toolbar-container.collapsed {
    height: 0;
    overflow: hidden;
  }

  div.toolbar-expanded-items {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
  }

  div.toolbar-container.xs div.toolbar-expanded-items, div.toolbar-container.xs div.toolbar-expanded-items div.map-attributes {
    flex-direction: column;
    align-items: flex-start;
  }

  div.toolbar-container div.additional-details {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }

  div.map-attributes {
    display: flex;
  }

  .toolbar-container.collapsed {
    height: 0;
    overflow: hidden;
  }

  .toolbar-container div.attrs {
    border-left: 1px solid lightgrey;
    padding: .5em .5em;
  }

  .toolbar-container.xs div.attrs {
    padding: .1em .5em;
  }

  
  .logo-container {
    display: flex;
    resize: both;
    overflow: hidden;
    /* align-items: stretch; */
  }

  .logo-container a {
    display: flex;
    width: 100%;
    height: 100%;

  }

  img.app-logo {
    object-fit: contain;
    width: 70px;
  }


  div.level-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

  }

  div.attrs > * {
    display: block;
  }

  div.attrs.address {
    flex-wrap: wrap;
    flex-shrink: 3;
    flex-grow: 0;
    word-wrap: break-word;
  }

  div.attrs h1 {
    font-size: .8em;
    font-weight: bold;
  }

  div.results.attrs.estimate {
    background-color: #732a25;
    box-shadow: inset 0 0 5px #000;
    color: #fff;
    padding-right: 20px;
    font-weight: bold;
  }

  div.results {
    display: flex;
    flex-shrink: 0;
    flex-direction: row;
    justify-content: flex-start;
  }

  .toolbar-controls, .visibility-toolbar {
    display: flex;
    flex-direction: row;
    
    /* align-self: flex-end; */
    justify-content: flex-end;
    flex-wrap: wrap;
    flex-shrink: 1;
    flex-grow: 3;
  }

  .toolbar-controls a, .visibility-toolbar a {
    display: block;
    border-radius: 10px;
    padding: 2px 10px;
    margin: 2px;
    border: 1px solid lightgrey;
    font-size: .8em;
    background-color: #f0f0f0;
    min-width: 100px;
    text-align: center;
  }

  div.toolbar-controls a:hover, div.visibility-toolbar a:hover {
    box-shadow: 0 0 3px #000;
  }

  .toolbar-controls a {
    color: #000;
  }  

  div.toolbar-container.collapsed {
    background-color: transparent;
  }

  div.toolbar-container.xs div.toolbar-controls, div.visibility-toolbar.hide {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  div.toolbar-container.collapsed div.toolbar-controls.hide a, div.visibility-toolbar.hide a {
    border-radius: 0 0 10px 10px;
    border-bottom: 1px solid lightgrey;
  }

  /* add a hover style to toolbar-container */
  div.toolbar-controls a:hover {
  }

  .visibility-toolbar {
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 10px 10px 0 0;
  }

  div.visibility-toolbar:hover {
  }

  div.visibility-toolbar:hover a {
    color: #fff;
  }

  .visibility-toolbar a {
    color: #000;
  }  
  
</style>

<script>
  window.Vue = require('vue').default;

  import Vuex from 'vuex'  
  
  export default {
    data: function() {
      return {}
    },
    computed: {
      hide() {
        return this.$store.state.mapDrag || this.$store.state.toolbarsHidden;
      },
      showSharingDetails() {
        return (this.$route.meta.showSharingDetails) ? true : false;
      },
      toolbarStyle() {
        return {
          opacity: this.hide ? 0 : 1,
          visibility: this.hide ? 'hidden' : 'visible',
          transition: 'opacity 0.5s ease, visibility 0.5s ease'
        };
      },
      toolbarClasses() {
        const classes = ['toolbar-container', this.$mq];              
        if (this.hide) {
          classes.push('collapsed');
        }
        return classes;
      },
      logoClasses() {
        const classes = ['logo-container'];
        if (this.$mq === 'xs') {
          classes.push(this.$mq);          
          return classes;
        }

        classes.push('level-item');
        return classes;
      },
      totalAreaString() {
        return (this.totalShapeCalculatedConverted) ? `${this.totalShapeCalculatedConverted.toLocaleString()} ${this.measureSuffix}` : '---';
      },
      projectName() {
        let name = this.$store.state.projectName || 'Measurement Results';
        if (name.length > 20 && this.$mq == 'sm') {
          name = name.substring(0, 30) + '...';
        }

        return name;
      },
      formattedAddress() {
        return this.displayAddress || this.address || '---'
      },
      ...Vuex.mapGetters([
        'totalShapeCalculatedConverted',
        'measureSuffix',
      ]),
      ...Vuex.mapState([
        'address',
        'displayAddress',
        'meta',
      ]),
      totalPrice() {
        return this.meta.estimate || null;
      },
      totalPriceFormatted() { 
        if (!this.totalPrice) return 'Custom quote required';
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.totalPrice);
      }
    },
    methods: {
      toggleToolbarVisibility() {
        this.$store.dispatch('setToolbarsHidden', !this.$store.state.toolbarsHidden);
      },
      editMap() {
        this.$router.push({ name: 'MapResultsEdit' });
      }      
    },
    mounted() {
      
    }
  }
</script>